(() => {
  'use strict';

  const B2B_NAV_SELECTOR = '.site-header--b2b-nav .nav-b2b';
  const DISCLOSURE_TAG = 'hover-disclosure';
  const DESKTOP_HOVER_QUERY = '(hover: hover) and (pointer: fine) and (min-width: 1024px)';
  const CLOSE_DELAY_MS = 200;
  const PATCH_FLAG = 'gamenessB2BHoverIntentPatched';
  const closeTimers = new WeakMap();

  function isDesktopB2BDisclosure(disclosure) {
    return disclosure.closest(B2B_NAV_SELECTOR) && window.matchMedia(DESKTOP_HOVER_QUERY).matches;
  }

  function clearCloseTimer(disclosure) {
    const timer = closeTimers.get(disclosure);
    if (!timer) return;

    window.clearTimeout(timer);
    closeTimers.delete(disclosure);
  }

  customElements.whenDefined(DISCLOSURE_TAG).then(() => {
    const HoverDisclosure = customElements.get(DISCLOSURE_TAG);
    const prototype = HoverDisclosure?.prototype;

    if (!prototype || prototype[PATCH_FLAG]) return;

    const showDisclosure = prototype.showDisclosure;
    const hideDisclosure = prototype.hideDisclosure;

    prototype[PATCH_FLAG] = true;

    prototype.showDisclosure = function (...args) {
      if (isDesktopB2BDisclosure(this)) {
        this.closest(B2B_NAV_SELECTOR)
          .querySelectorAll(`${DISCLOSURE_TAG}.is-visible`)
          .forEach((disclosure) => {
            if (disclosure === this) return;

            clearCloseTimer(disclosure);
            hideDisclosure.call(disclosure);
          });
      }

      clearCloseTimer(this);
      return showDisclosure.apply(this, args);
    };

    prototype.hideDisclosure = function (...args) {
      if (!isDesktopB2BDisclosure(this)) {
        clearCloseTimer(this);
        return hideDisclosure.apply(this, args);
      }

      clearCloseTimer(this);
      closeTimers.set(
        this,
        window.setTimeout(() => {
          closeTimers.delete(this);
          if (this.isConnected) hideDisclosure.apply(this, args);
        }, CLOSE_DELAY_MS),
      );
    };

    function closeImmediately(event) {
      const disclosure = event.target.closest?.(`${B2B_NAV_SELECTOR} ${DISCLOSURE_TAG}`);
      if (!disclosure || !isDesktopB2BDisclosure(disclosure)) return;

      const focusMovedWithinMenu = event.type === 'focusout' && disclosure.contains(event.relatedTarget);
      const isEscape = event.type === 'keyup' && event.code === 'Escape';
      if (focusMovedWithinMenu || (event.type === 'keyup' && !isEscape)) return;

      clearCloseTimer(disclosure);
      hideDisclosure.call(disclosure);
    }

    document.addEventListener('focusout', closeImmediately);
    document.addEventListener('keyup', closeImmediately);
  });
})();
